<template>
    <div>
        <v-dialog :max-width="Global.MODAL_WIDTH" persistent scrollable v-model="showSellModal" @close="close">
            <v-card>
                <v-card-title class="mb-0, pb-0">
                    <span class="headline">{{this.autoFillDataBudgetCode ? 'Nova Venda através do orçamento '+this.autoFillDataBudgetCode : modalTitleTxt }}</span>
                </v-card-title>
                <v-card-text class="mx-0, px-0">
                    <!--TABS-->
                    <v-tabs
                        v-model="active_tab"
                        color="blue-grey darken-2 white--text"
                        dark
                        slider-color="blue-grey darken-1"
                        grow
                    >
                        <!--Tab General-->
                        <v-tab :key="'tab_general'" ripple >Geral</v-tab>
                        <v-tab-item :key="'tab_general'" >
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <!--Client-->
                                    <v-flex xs12 sm6 md6 px-2>
                                        <v-autocomplete
                                            v-model="mForm.clients_id"
                                            @input="onClientSelected"
                                            :error-messages="clientErrors"
                                            :disabled="sellShow"
                                            @blur="$v.mForm.clients_id.$touch()"
                                            :items="clients"
                                            :loading="isLoadingClients"
                                            no-data-text="..."
                                            :search-input.sync="searchClientField"
                                            chips
                                            clearable
                                            :deletable-chips="!sellShow"
                                            hide-selected
                                            item-text="name"
                                            item-value="id"
                                            :label="'Digite para procurar '+entityName+'...'"
                                            solo
                                            :prefix="mForm.clients_id ? entityName+':' : ''"
                                        >
                                            <template slot="selection" slot-scope="{ item, selected }">
                                                <v-chip v-if="item" :selected="selected" :color="item.id === -1 ? 'blue-grey lighten-2' : 'blue-grey'" class="white--text" >
                                                    <v-icon left>mdi-coin</v-icon>
                                                    <span v-text="item.name"></span>
                                                </v-chip>
                                            </template>
                                            <template slot="item" slot-scope="{ item }">
                                                <v-list-tile-avatar v-if="item"
                                                    @click="setNewClientName(item)"
                                                    :color="item.id === -1 ? 'blue' : 'indigo'"
                                                    class="headline font-weight-light white--text"
                                                >
                                                    {{item.id === -1 ? '+' : item.name.charAt(0)}}
                                                </v-list-tile-avatar>
                                                <v-list-tile-content v-if="item" @click="setNewClientName(item)">
                                                    <v-list-tile-title v-text="item.id === -1 ? 'Criar: '+item.name : item.name"></v-list-tile-title>
                                                    <v-list-tile-sub-title v-text="item.symbol"></v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon>mdi-coin</v-icon>
                                                </v-list-tile-action>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <!--Employee-->
                                    <v-flex xs12 sm6 md6 px-2>
                                        <v-autocomplete
                                            v-model="mForm.users_made_id"
                                            :error-messages="employeeErrors"
                                            :disabled="sellShow"
                                            @blur="$v.mForm.users_made_id.$touch()"
                                            :items="employees"
                                            :loading="isLoadingEmployees"
                                            no-data-text="..."
                                            :search-input.sync="searchEmployeeField"
                                            @input="searchEmployees(this)"
                                            chips
                                            :deletable-chips="!sellShow"
                                            hide-selected
                                            item-text="name"
                                            item-value="id"
                                            clearable
                                            :label="madeByLabelTxt"
                                            solo
                                            :prefix="madeByLabelPrefixTxt"
                                        >
                                            <template slot="selection" slot-scope="{ item, selected }">
                                                <v-chip v-if="item" :selected="selected" color="blue-grey" class="white--text" >
                                                    <v-icon left>mdi-coin</v-icon>
                                                    <span v-text="item.name"></span>
                                                </v-chip>
                                            </template>
                                            <template slot="item" slot-scope="{ item }">
                                                <v-list-tile-avatar v-if="item"
                                                        :color="item.id === -1 ? 'blue' : 'indigo'"
                                                        class="headline font-weight-light white--text"
                                                >
                                                    {{ item.id === -1 ? '+' : item.name.charAt(0) }}
                                                </v-list-tile-avatar>
                                                <v-list-tile-content v-if="item">
                                                    <v-list-tile-title v-text="item.id === -1 ? 'Adicionar funcionário' : item.name"></v-list-tile-title>
                                                    <v-list-tile-sub-title v-text="item.symbol"></v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon>mdi-coin</v-icon>
                                                </v-list-tile-action>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <!--Sell date-->
                                    <v-flex xs12 sm6 md3 px-2>
                                        <v-menu
                                            ref="dialog"
                                            v-model="sell_date_modal"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    :value="computedSellDate"
                                                    label="Data"
                                                    :error-messages="sellDateErrors"
                                                    :disabled="sellShow"
                                                    @blur="$v.mForm.sell_date.$touch()"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="mForm.sell_date" no-title @input="sell_date_modal = false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <!--Sell channel-->
                                    <v-flex xs12 sm6 md3 px-2>
                                        <v-select v-model="mForm.types_sell_channel_id"
                                              item-text="name"
                                              item-value="id"
                                              :disabled="sellShow"
                                              :error-messages="sellChannelErrors"
                                              @blur="$v.mForm.types_sell_channel_id.$touch()"
                                              :items="sellChannels"
                                              label="Canal"></v-select>
                                    </v-flex>
                                    <!--Typology-->
                                    <v-flex xs12 sm6 md3 px-2>
                                        <v-select v-model="mForm.typology_id"
                                              item-text="name"
                                              :disabled="sellShow"
                                              item-value="id"
                                              :error-messages="typologyErrors"
                                              @blur="$v.mForm.typology_id.$touch()"
                                              :items="typologies"
                                              label="Tipologia"></v-select>
                                    </v-flex>
                                    <!--Tipo Operação-->
                                    <v-flex xs12 sm6 md3 px-2>
                                        <v-select v-model="mForm.types_operation_id"
                                              item-text="name"
                                              :disabled="sellShow"
                                              item-value="id"
                                              :error-messages="operationTypeErrors"
                                              @blur="$v.mForm.types_operation_id.$touch()"
                                              :items="operationTypes"
                                              label="Tipo operação"></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>

                        <!--Tab Articles-->
                        <v-tab :key="'tab_articles'" ripple >Artigos</v-tab>
                        <v-tab-item :key="'tab_articles'" >
                            <v-container>
                                <div>
                                    <v-data-table
                                        disable-initial-sort
                                        :headers="sell_line_headers"
                                        :items="sellLineList"
                                        :loading="sellLinesLoading"
                                        hide-actions
                                    >
                                        <template v-slot:items="props">
                                            <!--Article Name-->
                                            <td class="text-xs-left">{{ props.item.article_name ? props.item.article_name : props.item.article.name }}</td>
                                            <!--Detail-->
                                            <td class="text-xs-left" :class="props.item.detail ? '' : 'grey--text'">{{ props.item.detail ? props.item.detail : 'nenhuma'}}</td>
                                            <!--Sold Quantity-->
                                            <td class="text-xs-left" :class="props.item.sold_quantity ? '' : 'grey--text'">{{props.item.sold_quantity ? props.item.sold_quantity : 0}}</td>
                                            <!--Quantity to be delivered-->
                                            <td class="text-xs-left" :class="props.item.quantity_to_be_delivery ? '' : 'grey--text'">{{props.item.quantity_to_be_delivery  ? props.item.quantity_to_be_delivery : 0}}</td>
                                            <!--Cost Value-->
                                            <td class="text-xs-left">{{ props.item.sell_price | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                                            <!--Discount-->
                                            <td class="text-xs-right" :class="props.item.discount ? '' : 'grey--text'">{{props.item.discount ? props.item.discount : 0}} %</td>
                                            <!--Subtotal-->
                                            <td class="text-xs-left">{{ props.item.subtotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                                            <!--Actions-->
                                            <td class="justify-center layout px-0">
                                                <v-icon :disabled="sellShow" class="mr-2" @click="openSellLineDialog(props.item, props.index)">edit</v-icon>
                                                <v-icon :disabled="sellShow" class="mr-2" @click="virtuallyDeleteSellLine(props.item)">clear</v-icon>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </div>
                                <hr>
                                <v-btn v-if="!sellShow" color="blue-grey" class="white--text" @click="openSellLineDialog(null, -1)">
                                    <v-icon left dark>add</v-icon>Novo
                                </v-btn>
                            </v-container>
                        </v-tab-item>

                        <!--Tab Payment condition-->
                        <v-tab :key="'tab_payment'" ripple >Cond. Pagamento</v-tab>
                        <v-tab-item :key="'tab_payment'" >

                            
                            <div v-if="articleTransactionType === Global.ARTICLE_TRANSACTION_PURCHASE">
                                <file
                                    v-if="enableFile"
                                    label="Ficheiro comprovativo"
                                    @onFileDone="fileCallback($event)"
                                    :filePath="selectedSell.file_path"
                                ></file>
                            </div>

                            <!--Container of budget container-->
                            <v-container v-if="articleTransactionType === Global.ARTICLE_TRANSACTION_BUDGET">
                                <v-flex xs12 class="mb-4">
                                    <v-menu
                                        v-model="budgetDueDateModal"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="computedBudgetDueDate"
                                                label="Data vencimento"
                                                :error-messages="budgetDueDataErrors"
                                                :disabled="sellShow"
                                                @blur="$v.budgetDueData.$touch()"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="budgetDueData" no-title @input="budgetDueDateModal = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 v-if="articleTransactionType === Global.ARTICLE_TRANSACTION_BUDGET || autoFillDataBudgetCode" :style="!!autoFillDataBudgetCode ? 'margin-bottom: -40px' : ''">
                                    <v-textarea v-model="budgetDescription"
                                        :counter="$v.budgetDescription.$params.maxLength.max"
                                        :error-messages="budgetDescriptionErrors"
                                        @blur="$v.budgetDescription.$touch()"
                                        rows="3"
                                        outline
                                        :disabled="sellShow || !!autoFillDataBudgetCode"
                                        label="Descrição do Orçamento"
                                    ></v-textarea>
                                </v-flex>
                            </v-container>

                            <!--Container of non budget fields-->
                            <v-container v-if="articleTransactionType !== Global.ARTICLE_TRANSACTION_BUDGET">
                                <span>Condição Pagamento</span>
                                <v-radio-group v-if="showSellModal" v-model="mForm.types_payment_condition_id" row @change="changePaymentCondition">
                                    <v-radio :disabled="sellShow" label="Pronto Pagamento" :value="Types.purchase_condition.PRONTO_PAGAMENTO"></v-radio>
                                    <v-radio :disabled="sellShow" label="Pagamento a Prazo" :value="Types.purchase_condition.PAGAMENTO_A_PRAZO"></v-radio>
                                    <v-radio v-if="articleTransactionType !== Global.ARTICLE_TRANSACTION_PURCHASE" :disabled="sellShow" label="Avença" :value="Types.purchase_condition.PRESTACAO"></v-radio>
                                </v-radio-group>


                                <v-divider></v-divider>
                                <v-container grid-list-md class="blue-grey lighten-5" v-if="showPrestacao || showDeferredPayment">
                                    <v-layout wrap v-if="!sellShow">
                                        <v-flex xs12 sm3 md2 px-2 v-if="showPrestacao">
                                            <v-text-field type="number" v-model="newInvoice.interval"
                                                  :error-messages="newInvoiceIntervalErrors"
                                                  :disabled="sellShow"
                                                  :min="1"
                                                  @blur="$v.newInvoice.interval.$touch()"
                                                  @input="onIntervalChanged"
                                                  label="Intervalo(dias)"
                                                  :hint="newInvoiceIntervalHint"
                                                  persistent-hint></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm3 md3 px-2 v-if="showPrestacao">
                                            <v-text-field type="number" v-model="newInvoice.quantity"
                                                  :error-messages="newInvoiceQuantityErrors"
                                                  :disabled="sellShow"
                                                  :min="2"
                                                  @blur="$v.newInvoice.quantity.$touch()"
                                                  label="Quantidade"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm3 md3 px-2 v-if="showPrestacao">
                                            <v-menu
                                                ref="dialog3"
                                                v-model="date_first_instalment_modal"
                                                :disabled="sellShow"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        :value="computedNewInvoiceDueDate"
                                                        label="Data 1ª avença"
                                                        :disabled="sellShow"
                                                        :error-messages="newInvoiceDateFirstInstalmentErrors"
                                                        @blur="$v.newInvoice.dateFirstInstalment.$touch()"
                                                        prepend-icon="event"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="newInvoice.dateFirstInstalment" no-title @input="date_first_instalment_modal = false"></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2 px-2 v-if="showPrestacao || showDeferredPayment">
                                            <v-text-field type="number" v-model="newInvoice.daysTillDeadline"
                                                  :error-messages="newInvoiceDaysTillDeadlineErrors"
                                                  :disabled="sellShow"
                                                  :min="1"
                                                  @blur="$v.newInvoice.daysTillDeadline.$touch()"
                                                  label="Dias até vencimento"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2 px-2>
                                            <v-btn :disabled="checkGenerateButton()" color="indigo" class="white--text" @click="virtuallyGenerateInstallments">Gerar</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <v-divider></v-divider>
                                <!--Data table for invoices-->
                                <a-t-show-invoice-table v-if="sellShow"
                                    :invoices="selectedSell.invoices"
                                    :loading="sellInvoicesLoading"
                                    @onScheduledInvoiceFinish="fetchSellInvoices()"
                                ></a-t-show-invoice-table>
                                <v-data-table v-else
                                        disable-initial-sort
                                        :headers="showPrestacao ? sell_invoice_headers : sell_invoice_headers2"
                                        no-data-text="Nenhuma factura ainda"
                                        :items="invoices"
                                        :loading="sellInvoicesLoading"
                                        hide-actions
                                >
                                    <template v-slot:items="props">
                                        <!--Invoice Installment-->
                                        <td class="text-xs-left" v-if="showPrestacao">{{ props.item.installment }}/{{invoices ? invoices.length : 0}}</td>
                                        <!--Emission date-->
                                        <td class="text-xs-left">{{ props.item.emission_date | formatDate}}</td>
                                        <!--Due date-->
                                        <td class="text-xs-left">{{ props.item.due_date | formatDate}}</td>
                                        <!--Total -->
                                        <td class="text-xs-right">{{props.item.total_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                        <!--Actions-->
                                        <!--<td class="text-xs-right">-->
                                        <!--<v-icon class="mr-2" @click="virtuallyDeleteInvoice(props.item)">clear</v-icon>-->
                                        <!--</td>-->
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>
                    <v-divider></v-divider>
                    <v-container fluid pa-1>
                        <v-layout row>
                            <v-spacer color="grey"></v-spacer>
                            <v-flex shrink py-1 sx12>
                                <v-chip label outline color="grey darken-2" class="customCss" >Total Artigos: {{totalArticle | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</v-chip>
                            </v-flex>
                            <v-flex shrink py-1 sx12>
                                <v-chip label outline color="grey darken-2" class="customCss" >Desconto: {{computedDiscount | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</v-chip>
                            </v-flex>
                            <v-flex shrink py-1 sx12>
                                <v-chip label color="grey darken-1 grey--text text--lighten-2">Total: {{computedTotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</v-chip>
                            </v-flex>
                        </v-layout>
                        <!--<v-layout row>-->
                        <!--<v-spacer></v-spacer>-->
                        <!---->
                        <!--</v-layout>-->
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <!--Modal action buttons-->
                    <v-btn v-if="!loading_modal" depressed @click="close">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn v-if="!sellShow && active_tab !== 0" color="primary" @click="previousTab()">Anterior</v-btn>
                        <v-btn v-if="!sellShow && active_tab !== MAX_TAB" :disabled="checkSellModalConfirmButton()" color="primary" @click="nextTab">Seguinte</v-btn>
                        <v-btn v-if="!sellShow && active_tab === MAX_TAB" :disabled="checkSellModalSaveButton()" class="white--text" color="blue darken-4" @click="save()">Guardar</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Add payment-->
        <add-payment
            :paymentMethods="paymentMethods"
            :pendentValue="computedTotal"
            :isProntoPagamento="true"
            @onPaymentAdded="addPaymentCallback($event)"
        ></add-payment>

        <!--NewSellLine Form Modal-->
        <a-t-item-line
            @onItemAdded="aTItemLineAddedCallback($event)"
            @onItemUpdated="aTItemLineUpdatedCallback($event)"
            :has-discount="hasDiscount"
            :aTItemLineIndexEdit="aTItemLineIndexEdit"
            :article-transaction-type="articleTransactionType"
            :agreed_discount="computedChoosenClientDiscount"
        ></a-t-item-line>

        <!--InvoiceReceipt paper-->
        <invoice-receipt-paper></invoice-receipt-paper>
        <!-- <invoice-paper></invoice-paper> -->

        <observation-modal v-if="showObservationModal" @onSave="onObservationModalCallback($event)" :loading="loading_modal"></observation-modal>

    </div>
</template>

<script>
    import Vue from 'vue';
    import _ from 'lodash';
    import InvoiceReceiptPaper from '../invoice/InvoiceReceipt';
    import InvoicePaper from '../invoice/FormModal';
    import AddPayment from '../receipt/AddPayment';
    import {eventBus} from "../../main";
    import {mapActions, mapGetters} from 'vuex';
    import {maxLength, maxValue, minLength, minValue, numeric, required, requiredIf} from 'vuelidate/lib/validators'
    import {Permissions, Tax, Types, Global} from "../../config";
    import ObservationModal from '../extra/ObservationModal';
    import moment from 'moment';
    import ATItemLine from '../article_transaction/ATItemLine';
    import ATShowInvoiceTable from './ATShowInvoiceTable';
    import File from '../extra/File.vue';

    export default {
        name: "ATFormModal",

        beforeDestroy () {
            eventBus.$off('onPaymentAdded');
        },

        data () {
            return {
                Global,
                Types,
                Tax,

                MAX_TAB: 2,
                newContactName: '',
                active_tab: 0,
                sellLinesLoading: false, //loading for the sellLines in SellLines's dataTable
                sellInvoicesLoading: false,
                loading_modal: false,
                companies: [], //list of companies used in auto complete field (this is queried at the moment)
                clients: [],
                employees: [],
                groups: [],
                article_types: [],

                mForm: {
                    clients_id: '',
                    users_made_id: '',
                    sell_date: '',
                    types_sell_channel_id: '',
                    types_operation_id: '',
                    typology_id: '',
                },

                strNoStockHint: '',
                strMinStockHint: '',
                nonMutableStock: '',
                stock: '',
                min_stock: '',
                // showPrestacao: false,
                // showDeferredPayment: false,
                chosenClient: '',

                discount_percentage: true,
                budgetDescription: '',
                budgetDueData: '',
                file: '',
                enableFile: true,

                sellLine: null,
                sellLineList: [],
                aTItemLineIndexEdit: -1,

                //company form modal needed attributes
                company_types: [],
                company_categories: [],
                payments: [],

                //AutoComplete
                isLoading: false,
                isLoadingClients: false,
                isLoadingEmployees: false,
                isLoadingArticles: false,
                searchClientField: ' ',
                searchEmployeeField: ' ',

                // paymentCondition_id: '',

                uniqueInvoice: null,
                multipleInvoice: [],
                article_type: false,
                newClientName: '',
                // isClientExempted: '',

                observation: '',

                //
                sell_line_headers: [
                    { text: 'Artigo', align: 'left', sortable: false, value: 'article_name' },
                    { text: 'Detalhes', value: 'detail' },
                    { text: 'Quant. vendida', value: 'sold_quantity' },
                    { text: 'Quant. entregar', value: 'quantity_to_be_delivery' },
                    { text: 'Preço', value: 'sell_price' },
                    { text: 'Desconto (%)', value: 'discount' },
                    { text: 'Subtotal', value: 'subtotal' },
                    { text: 'Ações', align: 'right', value: '', sortable: false}
                ],

                sell_invoice_headers: [
                    { text: 'Prestação', value: 'installment'},
                    { text: 'Emissão', value: 'emission_date'},
                    { text: 'Vencimento', value: 'due_date'},
                    { text: 'Valor', align: 'right', value: 'total_value'},
                ],
                sell_invoice_headers2: [
                    { text: 'Emissão', value: 'emission_date'},
                    { text: 'Vencimento', value: 'due_date'},
                    { text: 'Valor', align: 'right', value: 'total_value'},
                ],

                // Date modals
                sell_date_modal: false,
                deadline_modal: false,
                date_first_instalment_modal: false,
                budgetDueDateModal: false,

                //New Invoice
                newInvoice: {
                    quantity: 2,
                    interval: 30,
                    daysTillDeadline: 15,
                    dateFirstInstalment: new Date().toISOString().substr(0, 10),
                },

                //money
                totalArticle: 0,
                discount: 0,

                sellIsAnAdvance: false,
                newInvoiceIntervalHint: '1 mês',
            }
        },

        props: {
            name: String,
            pluralName: String,
            saveUrl: String,
            modalTitle: String,
            articleTransactionType: Number,
            entityName: String,
            madeByLabel: String,
            hasDiscount: {
                type: Boolean,
                default: false,
            },
            entitySearchUrl: String,

            paymentConditions: Array,
            paymentMethods: Array,
            sellChannels: Array,
            active_states: Array,
            currencies: Array,
            operationTypes: Array,
            typologies: Array,
            countries: Array,
            cities: Array,
            autoFillDataBudgetCode: String,
            simplifiedModal: {
                type: Boolean,
                default: false
            },
            defaultSituationId: Number,
        },

        validations: {
            mForm: {
                clients_id: {
                    // numeric,
                    required,
                },
                users_made_id: {
                    // numeric,
                    required,
                },
                sell_date: {
                    required,
                },
                types_sell_channel_id: {
                    required,
                },
                types_operation_id: {
                    required,
                },
                typology_id:{
                    required,
                },
                series: {
                    numeric,
                    required,
                },
                types_currency_id: {
                    // required,
                },
            },
            budgetDescription: {
                required: requiredIf(function (nestedModel) {
                    return this.articleTransactionType === Global.ARTICLE_TRANSACTION_BUDGET;
                }),
                maxLength: maxLength(1000),
            },
            budgetDueData: {
                required: requiredIf(function (nestedModel) {
                    return this.articleTransactionType === Global.ARTICLE_TRANSACTION_BUDGET;
                }),
            },

            newInvoice: {
                interval: {
                    minValue: minValue(1),
                    required
                },
                quantity: {
                    minValue: minValue(1),
                    required
                },
                daysTillDeadline: {
                    minValue: minValue(1),
                    required
                },
                dateFirstInstalment: {
                    required
                }
            }
        },

        components: {
            InvoiceReceiptPaper,
            InvoicePaper,
            AddPayment,
            ObservationModal,
            ATItemLine,
            ATShowInvoiceTable,
            File,
        },

        watch: {
            selectedSell(){
                // this.sellLineList = [];
                // if(this.mForm.made_by_user){
                    // this.employees = [this.mForm.made_by_user];
                // }
                // if(this.mForm.client) {
                    // this.clients = [this.mForm.client];
                // }
                // if(this.mForm.id){
                    // this.getSellLines();
                // }
            },
            showPaymentModal (){
                // if(!this.showPaymentModal) return;
                this.consoleLog("totalArticle: ", this.totalArticle);
                this.consoleLog("discount::: ", this.computedDiscount);
                this.consoleLog("computedTotal::", this.computedTotal);
            },

            showSellModal(){
                if(this.showSellModal){
                    this.onSellFormOpened();
                }
            },

            searchClientField (){
                this.searchClients(this);
            },

            searchEmployeeField(){
                this.searchEmployees(this);
            },

            sellLine(){
                this.calcTotalArticleAndDiscount();
                if(this.invoices && this.invoices.length > 0){
                    this.virtuallyGenerateInstallments();
                }
            },

        },


        methods: {
            onSellFormOpened(){
                if(!this.selectedSell.id){
                    this.consoleLog('--no sell--', this.selectedSell);
                    this.sellLine = this.getNewEmptySellLine();
                    this.mForm.types_sell_channel_id = this.sellChannels[0].id;
                    this.mForm.types_operation_id = this.operationTypes[0].id;
                    this.mForm.sell_date = new Date().toISOString().substr(0, 10);
                    this.employees = [this.loggedUser];
                    this.mForm.users_made_id = this.loggedUser.id;
                    // this.paymentCondition = null;

                }else{
                    this.consoleLog('--has sell--', this.selectedSell);
                    this.clients = [this.selectedSell.client];
                    this.employees = [this.selectedSell.made_by_user];
                    
                    this.mForm.clients_id = this.selectedSell.clients_id;
                    this.mForm.users_made_id = this.selectedSell.users_made_id;
                    this.mForm.sell_date = this.selectedSell.sell_date;
                    this.mForm.types_sell_channel_id = this.selectedSell.types_sell_channel_id;
                    this.mForm.typology_id = this.selectedSell.types_typology_id;
                    this.mForm.types_operation_id = this.selectedSell.types_operation_id;
                    this.mForm.types_payment_condition_id = this.getTypePaymentConditionId();
                    // this.consoleLog('types_payment_condition_id: ', this.mForm.types_payment_condition_id);

                    this.sellLineList = this.getATItemLines() || [];

                    this.budgetDescription = this.selectedSell.description;
                    this.budgetDueData = this.selectedSell.due_date;
                }
                this.calcTotalArticleAndDiscount();
            },

            //get the purchase_lines and sell_lines accordinglyi 
            getATItemLines(){
                if(this.articleTransactionType === Global.ARTICLE_TRANSACTION_PURCHASE){
                    return this.selectedSell.purchase_lines;
                }else{
                    return this.selectedSell.sell_lines;
                }
            },

            getTypePaymentConditionId(){
                    this.consoleLog('---selectedSell: ', this.selectedSell);
                if(!this.selectedSell.invoices) return 0;
                let firstInvoice = this.selectedSell.invoices[0];
                if(firstInvoice) return firstInvoice.types_payment_condition_id;
                return 0;
            },

            forceRefreshFileInput(){
                this.enableFile = false;
                let vm = this;
                setTimeout(() => {
                    vm.enableFile = true;
                }, 50);
            },

            nextTab(){
                if(this.active_tab === this.MAX_TAB){
                    this.active_tab = 0;
                }else{
                    this.active_tab++;
                }
            },

            previousTab(){
                if(this.active_tab === 0) return;
                this.active_tab--;
            },

            fileCallback(payload){
                this.file = payload;
            },

            aTItemLineAddedCallback(sellLine){
                this.consoleLog('aTItemLineAddedCallback: ', sellLine);
                this.sellLineList.push(sellLine);
                this.calcTotalArticleAndDiscount();
            },

            aTItemLineUpdatedCallback(payload){
                this.consoleLog('aTItemLineUpdatedCallback: ', payload);
                this.sellLineList.splice(payload.index, 1, payload.item);
                this.calcTotalArticleAndDiscount();
            },

            wordsToUpperCase(str) {
                let splitStr = str.toLowerCase().split(' ');
                for (let i = 0; i < splitStr.length; i++) {
                    // You do not need to check if i is larger than splitStr length, as your for does that for you
                    // Assign it back to the array
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                // Directly return the joined string
                return splitStr.join(' ');
            },

            setNewClientName(client){
                if(client.id > 0) {
                    this.newClientName = '';
                    return;
                }
                this.newClientName = this.wordsToUpperCase(this.searchClientField);
            },

            addPaymentCallback(payload){
                this.consoleLog('addPaymentCallback', payload);
                this.payments = payload.payments;
                this.observation = payload.paymentDescription;
                this.addSell();
            },
            onObservationModalCallback(observation){
                this.observation = observation;
                this.addSell();
            },

            calcTotalArticleAndDiscount(){
                let totalPrice = 0;
                let totalDiscount = 0;
                let sellLine = 0;
                let totalArticlesToBeDelivered = 0;
                if(!this.selectedSell || !this.sellLineList) return 0;
                try{
                    for(let i=0; i<this.sellLineList.length; i++){
                        sellLine = this.sellLineList[i];
                        // let totalQuantity = parseInt(sellLine.sold_quantity) + parseInt(sellLine.quantity_to_be_delivery);
                        totalPrice +=(sellLine.sell_price *  parseInt(sellLine.sold_quantity));

                        let discount = totalPrice * sellLine.discount / 100;
                        totalDiscount += discount;

                        if(sellLine.quantity_to_be_delivery > 0) totalArticlesToBeDelivered++;
                    }
                }catch (e) {
                    this.consoleLog(e);
                }
                this.totalArticle = totalPrice;
                this.discount = totalDiscount;
                this.sellIsAnAdvance = totalArticlesToBeDelivered > 0;
            },

            checkIfNameExistInList(mArray, name){
                for(let i=0; i<mArray.length; i++){
                    if(mArray[i].name.toUpperCase() === name.toUpperCase()) return true;
                }
                return false;
            },

            searchClients: _.debounce((vm) => {
                if (!vm.searchClientField) return;
                vm.isLoadingClients = true;

                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + vm.getToken;
                let url = vm.entitySearchUrl+'' + vm.searchClientField;
                vm.consoleLog('serachUrl', url);
                Vue.axios.get(url)
                    .then(response => {
                        vm.consoleLog('searchClients:', response);
                        if (!response.data.success) {
                            //do nothing
                            return;
                        }

                        vm.clients = response.data.response || [];
                        if(!vm.checkIfNameExistInList(vm.clients, vm.searchClientField) && vm.hasPermission(Permissions.CLIENT_ADD)){
                            vm.clients.push({
                                id: -1,
                                // name: 'Adicionar novo cliente'
                                name: vm.searchClientField ? vm.searchClientField : 'a'
                            })
                        }



                    }).catch(error => {
                    // do nothing
                }).finally(() => {
                    vm.isLoadingClients = false
                });
            }, 700),

            searchEmployees: _.debounce((vm) => {
                if (!vm.searchEmployeeField) return;
                vm.isLoadingEmployees = true;

                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + vm.getToken;
                Vue.axios.get('user/search/' + vm.searchEmployeeField)
                    .then(response => {
                        vm.consoleLog('searchEmployees:', response);
                        if (!response.data.success) {
                            //do nothing
                            return;
                        }

                        vm.employees = response.data.response || [];
                        // if(vm.clients.length === 0){
                        //     vm.employees.push({
                        //         id: -1,
                        //         // name: 'Adicionar novo funcionario'
                        //         name: vm.searchEmployeeField ? vm.searchEmployeeField : 'a'
                        //     })
                        // }



                    }).catch(error => {
                    // do nothing
                }).finally(() => {
                    vm.isLoadingEmployees = false
                });
            }, 700),

            searchArticle: _.debounce((vm) => {
                if (!vm.searchArticleField) return;
                vm.isLoadingArticles= true;

                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + vm.getToken;
                Vue.axios.get('article/search/' + vm.searchArticleField)
                    .then(response => {
                        vm.consoleLog(response);
                        if (!response.data.success) {
                            //do nothing
                            return;
                        }

                        vm.articles = response.data.response;


                    }).catch(error => {
                    // do nothing
                }).finally(() => {
                    vm.isLoadingArticles = false
                });
            }, 700),

            getTaxPercentage(){
                let percentage = 0;
                let type = this.loggedUser.group.company.types_company_types_id;
                if( type === Types.company_type.REMPE){
                    percentage = Tax.TAX_REMPE;
                }else if(type === Types.company_type.CONTABILIDADE_ORGANIZADA){
                    percentage = Tax.TAX_CONTABILIDADE_ORGANIZADA;
                }

                return percentage;
            },

            getDocumentType(){
                switch (this.mForm.types_payment_condition_id) {
                    case Types.purchase_condition.PRONTO_PAGAMENTO:
                        return Types.document_type.FACTURA_RECIBO;
                    case Types.purchase_condition.PRESTACAO:
                        return Types.document_type.FACTURA;
                    case Types.purchase_condition.PAGAMENTO_A_PRAZO:
                        return Types.document_type.FACTURA;
                }
            },

            getSituationId(){
                // this.consoleLog('paymentCondition_id: '+paymentCondition_id);
                switch (this.mForm.types_payment_condition_id) {
                    case Types.purchase_condition.PRONTO_PAGAMENTO:
                        return Types.sell_situation.CONCRETIZADO;
                    case Types.purchase_condition.PRESTACAO:
                        return Types.sell_situation.EM_ANDAMENTO;
                    case Types.purchase_condition.PAGAMENTO_A_PRAZO:
                        return Types.sell_situation.EM_ANDAMENTO;
                    default:
                        return '';
                }
            },

            addSell(){
                // this.consoleLog('sellChannel vv');
                try{
                    this.loading_modal = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    let body = {
                        // code: '', //set in backend
                        clients_id: this.mForm.clients_id,
                        client_name_to_add: this.newClientName,
                        companies_id: this.loggedUser.group.company.id,
                        // //$sell->model_107_id
                        sell_date: this.mForm.sell_date,
                        total_installments: this.showPrestacao ? this.invoices.length : 0,

                        types_situation_id: this.defaultSituationId ? this.defaultSituationId : this.getSituationId(),
                        types_sell_channel_id: this.mForm.types_sell_channel_id,
                        types_document_id: this.getDocumentType(),
                        types_payment_condition_id: this.mForm.types_payment_condition_id,
                        types_operation_id: this.mForm.types_operation_id,
                        types_typology_id: this.mForm.typology_id,
                        // series: this.mForm.series,
                        types_book_id: Types.books.VENDAS,
                        types_currency_id: Types.currency.ECV,
                        users_made_id: this.mForm.users_made_id,
                        users_registered_id: this.loggedUser.id,
                        sell_tax: this.getTaxPercentage(),
                        // sell_tax_money: this.getTax(),
                        total_value: this.computedTotal,
                        detail: this.observation,
                        budget_description: this.budgetDescription,
                        budget_due_date: this.budgetDueData,

                        file: this.file,
                        
                        sell_lines: JSON.stringify(this.sellLineList),
                        invoices: JSON.stringify(this.invoices),
                        budget_id: this.autoFillDataBudgetCode ? this.selectedSell.id : '',

                    };
                    if(this.mForm.types_payment_condition_id === Types.purchase_condition.PRONTO_PAGAMENTO){
                        body.payments = JSON.stringify(this.payments);
                    }
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.post(this.saveUrl, body)
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.selectedInvoice = response.data.response.invoice_receipt;
                        this.$emit('onFormModalDone', {
                            articleTransactionType: this.articleTransactionType,
                            selectedItem: this.selectedInvoice,
                        });

                        this.close();

                        //Open InvoiceReceiptPaper
                        if(this.selectedInvoice.types_document_id === Types.document_type.FACTURA_RECIBO) {
                            this.showInvoiceReceiptPaperModal = true;
                        }else if(this.selectedInvoice.types_payment_condition_id === Types.document_type.FACTURA){
                            this.showInvoiceModal = true;
                        }

                        this.showSnackBar(this.name+' adicionado com sucesso', 'success');
                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao adicionar '+this.name, 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.showObservationModal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao adicionar '+this.name+'!', 'error');
                    this.loading_modal = false;
                }
            },

            fetchSellInvoices(){
                this.sellInvoicesLoading = true;
                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.get('fetchSellInvoices/'+this.selectedSell.id)
                    .then(response => {
                        this.consoleLog('fetchSellInvoices', response);
                        if (!response.data.success) {
                            //do nothing
                            return;
                        }

                        this.selectedSell.invoices = response.data.response;
                    }
                ).catch(error => {
                    this.consoleLog(error);
                }).finally( ()=> {
                    this.sellInvoicesLoading = false;
                });
            },

            close() {
                this.consoleLog('close', 'clear values');
                this.mForm.clients_id = '';
                this.mForm.users_made_id = '';
                this.mForm.sell_date = '';
                this.mForm.types_sell_channel_id = '';
                this.mForm.typology_id = '';
                this.mForm.types_operation_id = '';
                this.sellLineList = [];
                this.forceRefreshFileInput();

                this.showSellModal = false;
                this.newContactName = '';
                this.totalArticle = '';
                this.discount = '';
                // this.paymentCondition = '';
                this.mForm.types_payment_condition_id = '';
                this.employees = [];
                this.newClientName = '';
                this.searchClientField = '';
                this.clients = [];
                this.budgetDescription = '';
                this.budgetDueData = '';
                this.active_tab = 0;
                this.resetNewInvoice();
                this.$v.$reset();

                setTimeout(() => {
                    // this.selectedIndex = -1;
                    // this.selectedSell = this.getNewCompany();
                    // this.active_tab = 0;
                    this.loading = false;
                    this.sellShow = false;
                }, 300);
            },

            resetNewInvoice(){
                this.invoices = [];
                this.newInvoice = {
                    quantity: 2,
                    interval: 30,
                    daysTillDeadline: 15,
                    dateFirstInstalment: new Date().toISOString().substr(0, 10),
                };
                // this.paymentCondition = '';
                this.mForm.types_payment_condition_id = '';
            },

            save () {
                if(this.mForm.types_payment_condition_id === Types.purchase_condition.PRONTO_PAGAMENTO) {
                    // this.consoleLog('Openning payments');
                    this.showPaymentModal = true;
                }else if(this.articleTransactionType === Global.ARTICLE_TRANSACTION_SELL){
                    this.showObservationModal = true;
                }else{
                    if(moment(this.mForm.sell_date).isAfter(moment(this.budgetDueData))){
                        this.showSnackBar('Data emissão não pode ser superior a data vencimento', 'info');
                        return;
                    }
                    this.addSell();
                }
            },

            openSellLineDialog(item, index){
                this.consoleLog('openSellLineDialogIndex', index);
                if(!this.mForm.clients_id){
                    this.showSnackBar('Escolha um '+this.entityName+' antes de adicionar artigos', 'info');
                    return;
                }
                this.aTItemLineIndexEdit = index;
                let temp = item ? item : this.getNewEmptySellLine();
                temp.agreed_discount = this.computedChoosenClientDiscount;
                this.selectedArticleInSellLine = temp;

                this.showNewSellLineModal = true;
                // eventBus.$emit('onSellLineModalOpen', this.sellLine, this.articles, index, this.computedChoosenClientDiscount);
            },

            virtuallyDeleteSellLine(item){
                let index = this.sellLineList.indexOf(item);
                this.sellLineList.splice(index, 1);
                this.calcTotalArticleAndDiscount();
            },

            virtuallyDeleteInvoice(item){
                let index = this.invoices.indexOf(item);
                this.invoices.splice(index, 1);
            },

            getNewEmptySellLine(){
                return {
                    sells_id: '',
                    articles_id: '',
                    detail: '',
                    sell_price: '',
                    discount: '',
                    sold_quantity: 1,
                    quantity_to_be_delivery: 0,
                    subtotal: 0,
                    article_name: ''
                };
            },

            // getArticleById(){
            //     for(let i=0; i<this.articles.length; i++){
            //         if(this.articles[i].id === this.sellLine.articles_id)
            //             return this.articles[i];
            //     }
            // },

            checkSellModalConfirmButton(){
                if(!this.selectedSell || !this.sellLineList) return true;//true  will disable the button
                let tab2 = this.active_tab === 1 ? this.sellLineList.length === 0 : false;
                return tab2 || this.checkTab1();

            },

            checkTab1(){
                return this.$v.mForm.clients_id.$invalid || this.$v.mForm.users_made_id.$invalid
                    || this.$v.mForm.sell_date.$invalid || this.$v.mForm.types_sell_channel_id.$invalid
                    || this.$v.mForm.typology_id.$invalid || this.$v.mForm.types_operation_id.$invalid;
            },

            checkSellModalSaveButton(){
                if(this.articleTransactionType === Global.ARTICLE_TRANSACTION_BUDGET){
                    return !(!this.checkTab1() && this.sellLineList && this.sellLineList.length > 0 && !this.$v.budgetDescription.$invalid && !this.$v.budgetDueData.$invalid);
                }
                return !this.invoices || !(this.invoices.length > 0) || this.checkTab1() || !this.sellLineList || this.sellLineList.length <= 0;
            },

            // checkSellLineModalConfirmButton(){
            //     let quantity = (parseInt(this.sellLine.sold_quantity) + parseInt(this.sellLine.quantity_to_be_delivery)) > 0;
            //     return this.$v.sellLine.articles_id.$invalid || !quantity
            //         || this.$v.sellLine.sold_quantity.$invalid;
            // },

            checkGenerateButton(){
                return this.$v.newInvoice.interval.$invalid || this.$v.newInvoice.quantity.$invalid
                    || this.$v.newInvoice.dateFirstInstalment.$invalid || this.$v.newInvoice.daysTillDeadline.$invalid
                    || this.sellShow;
            },

            getDividedBy(value){
                return this.newInvoice.interval % value === 0 ? this.newInvoice.interval / value : 0;
            },

            onIntervalChanged(){
                let var1 = this.getDividedBy(30);
                this.newInvoiceIntervalHint = var1 === 0 ? '' : var1 === 1 ? var1+' mês' : var1+' meses';
                let newDate = var1 !== 0 ? moment().add(var1, 'months') : moment().add(this.newInvoice.interval, 'days');
                this.computedNewInvoiceDueDate = newDate.valueOf();
            },

            setupNewInvoiceFields(canChangeDeadLine = false){
                // this.invoices = [];
                return {
                    code: '',
                    types_payment_condition: this.paymentCondition,
                    installment: '1',
                    detail: 'Detalhe',
                    emission_date: moment(),
                    due_date: canChangeDeadLine ? moment().add(this.newInvoice.daysTillDeadline, 'days') : moment(),
                    total_value: this.computedTotal,
                    pendent_value: this.mForm.types_payment_condition_id === Types.purchase_condition.PRONTO_PAGAMENTO ? 0 : this.computedTotal,
                    // pendent_value: this.paymentCondition_id,
                }
            },

            virtuallyGenerateInstallments(){
                this.invoices = [];
                this.multipleInvoice = [];

                let date = this.newInvoice.dateFirstInstalment ? moment(this.newInvoice.dateFirstInstalment) : moment();
                let var2 = this.getDividedBy(30);
                let dividable = 0;

                let priceShard = 0;

                if(this.newInvoice.quantity > 0){
                    dividable = this.computedTotal % this.newInvoice.quantity;
                    if(dividable === 0){
                        priceShard = this.computedTotal / this.newInvoice.quantity;
                    }else{
                        priceShard = this.computedTotal / this.newInvoice.quantity;
                        // this.consoleLog(">>>Normal Value: "+priceShard);
                        priceShard = Math.floor(priceShard);
                    }

                }

                if(this.mForm.types_payment_condition_id !== Types.purchase_condition.PRESTACAO){
                    this.newInvoice.quantity = 1;
                }

                for(let i=0; i<this.newInvoice.quantity;i++){

                    if(i===0){
                        //don't add interval,
                    }
                    else if(var2 !== 0){
                        date = date.clone().add(var2, 'months');
                    }else{
                        date = date.clone().add(this.newInvoice.interval, 'days');
                    }

                    //check if last loop
                    if(i === (this.newInvoice.quantity - 1)){
                        priceShard += dividable;
                        this.consoleLog("LAST SHARD SHALL HAVE: "+priceShard);
                    }

                    this.multipleInvoice.push({
                        types_payment_condition_id: this.paymentCondition,
                        installment: i+1,
                        emission_date: date,
                        due_date: moment(date).add(this.newInvoice.daysTillDeadline, 'days'),
                        detail: 'Detalhe',
                        pendent_value: this.computedTotal,
                        total_value: this.computedTotal,
                    });
                }
                this.invoices = this.multipleInvoice;
            },

            virtualInvoices(id){
                this.multipleInvoice = [];
                if(id === Types.purchase_condition.PRONTO_PAGAMENTO){
                    this.invoices = [this.setupNewInvoiceFields()];

                }else if(id === Types.purchase_condition.PRESTACAO){
                    this.invoices = this.multipleInvoice;
                }else if(id === Types.purchase_condition.PAGAMENTO_A_PRAZO){
                    this.invoices = [this.setupNewInvoiceFields(true)];
                }
            },

            onClientSelected(){
                // this.consoleLog('Client selected');
                let vm = this;
                let found = this.clients.find(function(element){
                    vm.chosenClient = element.id === vm.mForm.clients_id ? element : undefined;
                    return vm.chosenClient;
                });

                // if(found) {
                //     this.isClientExempted = found.exempted;
                // }
            },

            changePaymentCondition(){
                let value = this.mForm.types_payment_condition_id;
                this.consoleLog('CHANGING payment condition: '+value);
                // this.paymentCondition_id = value;
                this.virtualInvoices(value);
                // this.showDeferredPayment = (value === Types.purchase_condition.PAGAMENTO_A_PRAZO);
                this.$store.dispatch('setSellPaymentCondition', value);
            }
        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),
            showPrestacao(){
                return this.mForm.types_payment_condition_id === Types.purchase_condition.PRESTACAO;
            },
            showDeferredPayment(){
                return this.mForm.types_payment_condition_id === Types.purchase_condition.PAGAMENTO_A_PRAZO;
            },
            modalTitleTxt(){
                if(this.selectedSell.id){
                    return this.modalTitle+': '+this.selectedSell.code+'/'+this.selectedSell.series;
                }
                return this.modalTitle;
            },
            computedSellDate:{
                get(){
                    return this.mForm.sell_date ? moment(this.mForm.sell_date).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY');
                },
                set(value){
                    this.mForm.sell_date = new Date(value).toISOString().substr(0, 10);
                }
            },

            showNewSellLineModal:{
                get(){
                    return this.$store.getters.getShowNewSellLineModal;
                },
                set(value){
                    this.$store.dispatch('setShowNewSellLineModal', value);
                }
            },

            invoices: {
                get(){
                    return this.$store.getters.getSellinvoices;
                },
                set(value){
                    this.$store.dispatch('setSellInvoices', value);
                }
            },

            showObservationModal: {
                get(){
                    return this.$store.getters.getShowObservationModal;
                },
                set(value){
                    this.$store.dispatch('setShowObservationModal', value);
                }
            },

            // paymentCondition: {
            //     get(){
            //         return this.$store.getters.paymentCondition;
            //     },
            //     set(value){
            //         this.consoleLog('CHANGING payment condition: '+value);
            //         this.paymentCondition_id = value;
            //         this.virtualInvoices(value);
            //         this.showPrestacao = (value === Types.purchase_condition.PRESTACAO);
            //         this.showDeferredPayment = (value === Types.purchase_condition.PAGAMENTO_A_PRAZO);
            //         this.$store.dispatch('setSellPaymentCondition', value);
            //     }
            // },

            selectedArticleInSellLine: {
                get() {
                    return this.$store.getters.getSelectedArticleInSellLine;
                },
                set(value) {
                    this.$store.dispatch('setSelectedArticleInSellLine', value);
                }
            },

            computedNewInvoiceDueDate: {
                get(){
                    return this.newInvoice.dateFirstInstalment ? moment(this.newInvoice.dateFirstInstalment).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY');
                },
                set(value){
                    this.newInvoice.dateFirstInstalment = new Date(value).toISOString().substr(0, 10);
                }
            },
            computedBudgetDueDate: {
                get(){
                    return this.budgetDueData ? moment(this.budgetDueData).format('DD-MM-YYYY') : '';
                },
                set(value){
                    this.budgetDueData = new Date(value).toISOString().substr(0, 10);
                },
            },
            showPaymentModal: {
                get(){ return this.$store.getters.getShowPaymentModal; },
                set(value){ this.$store.dispatch('setShowPaymentModal', value); }
            },
            loggedUser:{
                get() {
                    return this.$store.getters.loggedUser;
                },
                set(value){
                    this.$store.dispatch('loggedUser', value);
                }
            },

            madeByLabelTxt(){
                return "Digite para procurar "+this.madeByLabel+"...";
            },

            madeByLabelPrefixTxt(){
                return this.mForm.users_made_id ? this.madeByLabel+':' : '';
            },

            computedDiscount(){
                let sellLine;
                let totalDiscount = 0;
                if(!this.selectedSell || !this.sellLineList) return 0;
                try{
                    for(let i=0; i<this.sellLineList.length; i++){
                        sellLine = this.sellLineList[i];
                        let price = (sellLine.sell_price * sellLine.sold_quantity);
                        let discount = price * sellLine.discount / 100;
                        totalDiscount += discount;
                    }
                }catch (e) {
                    this.consoleLog(e);
                }
                return totalDiscount;
            },

            computedChoosenClientDiscount(){
                if(!this.chosenClient) return 0;
                return this.chosenClient.agreed_discount;
            },

            computedTotal(){
                this.consoleLog("totalArticle: "+this.totalArticle);
                this.consoleLog("discounttt: "+this.computedDiscount);
                this.consoleLog("sellLineList: "+this.sellLineList);
                return this.totalArticle - this.computedDiscount;
            },

            showSellModal: {
                get(){
                    return this.$store.getters.getShowSellModal;
                },
                set(value){
                    this.$store.dispatch('setShowSellModal', value);
                }
            },
            selectedSell: {
                get(){
                    return this.$store.getters.getSelectedSell;
                },
                set(value){
                    this.$store.dispatch('setSelectedSell', value);
                }
            },
            sellShow: {
                get(){
                    return this.$store.getters.getSellShow;
                },
                set(value){
                    this.$store.dispatch('setSellShow', value);
                }
            },
            selectedCliente: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedUser: {
                get(){
                    return this.$store.getters.getSelectedUser;
                },
                set(value){
                    this.$store.dispatch('setSelectedUser', value);
                }
            },
            selectedArticle: {
                get(){
                    return this.$store.getters.getSelectedArticle;
                },
                set(value){
                    this.$store.dispatch('setSelectedArticle', value);
                }
            },
            selectedInvoice: {
                get(){
                    return this.$store.getters.getSelectedInvoice;
                },
                set(value){
                    this.$store.dispatch('setSelectedInvoice', value);
                }
            },
            showInvoiceReceiptPaperModal: {
                get() {
                    return this.$store.getters.getShowInvoiceReceiptPaperModal;
                },
                set(value) {
                    this.$store.dispatch('setShowInvoiceReceiptPaperModal', value);
                    if(this.selectedInvoice.types_document_id === Types.document_type.FACTURA_RECIBO) {
                        eventBus.$emit('onInvoiceReceiptOpened', value);
                    }
                }
            },

            formTitle () {
                let title = this.name;
                return this.sellShow ? title : (this.selectedSell.id ? 'Editar '+title : 'Nova '+title);
            },
            clientErrors() {
                const errors = [];
                if (!this.$v.mForm.clients_id.$dirty) return errors;
                !this.$v.mForm.clients_id.required && errors.push('Escolha um '+this.entityName+'');
                return errors
            },
            employeeErrors() {
                const errors = [];
                if (!this.$v.mForm.users_made_id.$dirty) return errors;
                !this.$v.mForm.users_made_id.required && errors.push('Escolha um vendedor');
                return errors
            },
            sellDateErrors () {
                const errors = [];
                if (!this.$v.mForm.sell_date.$dirty) return errors;
                !this.$v.mForm.sell_date.required && errors.push('Introduza uma data');
                return errors
            },
            sellChannelErrors () {
                const errors = [];
                if (!this.$v.mForm.types_sell_channel_id.$dirty) return errors;
                // !this.$v.mForm.types_sell_channel_id.numeric && errors.push('Tem de ser um número');
                !this.$v.mForm.types_sell_channel_id.required && errors.push('Escolha canal de venda');
                return errors
            },
            typologyErrors(){
                const errors = [];
                if (!this.$v.mForm.typology_id.$dirty) return errors;
                !this.$v.mForm.typology_id.required && errors.push('Escolha tipologia');
                return errors
            },
            operationTypeErrors(){
                const errors = [];
                if (!this.$v.mForm.types_operation_id.$dirty) return errors;
                !this.$v.mForm.types_operation_id.required && errors.push('Escolha tipo de operação');
                return errors
            },
            currencyError(){
                const errors = [];
                if(!this.$v.mForm.types_currency_id.$dirty) return errors;
                // !this.$v.mForm.types_currency_id.required && errors.push('Escolha uma moeda');
                return errors;
            },

            //new invoice errors
            newInvoiceIntervalErrors(){
                const errors = [];
                if (!this.$v.newInvoice.interval.$dirty) return errors;
                !this.$v.newInvoice.interval.minValue && errors.push('Introduza número positivo');
                !this.$v.newInvoice.interval.required && errors.push('Introduza o intervalo');
                return errors
            },
            newInvoiceQuantityErrors(){
                const errors = [];
                if (!this.$v.newInvoice.quantity.$dirty) return errors;
                !this.$v.newInvoice.quantity.minValue && errors.push('Introduza número positivo');
                !this.$v.newInvoice.quantity.required && errors.push('Introduza intervalo');
                return errors
            },
            newInvoiceDateFirstInstalmentErrors(){
                const errors = [];
                if (!this.$v.newInvoice.dateFirstInstalment.$dirty) return errors;
                !this.$v.newInvoice.dateFirstInstalment.required && errors.push('Escolha uma data');
                return errors
            },
            newInvoiceDaysTillDeadlineErrors(){
                const errors = [];
                if (!this.$v.newInvoice.daysTillDeadline.$dirty) return errors;
                !this.$v.newInvoice.daysTillDeadline.minValue && errors.push('Introduza número positivo');
                !this.$v.newInvoice.daysTillDeadline.required && errors.push('Introduza número dias');
                return errors
            },
            budgetDescriptionErrors(){
                const errors = [];
                if (!this.$v.budgetDescription.$dirty) return errors;
                !this.$v.budgetDescription.maxLength && errors.push('Máximo de 1000 caracteres');
                !this.$v.budgetDescription.required && errors.push('Introduza a descrição do orçamento');
                return errors
            },
            budgetDueDataErrors () {
                const errors = [];
                if (!this.$v.budgetDueData.$dirty) return errors;
                !this.$v.budgetDueData.required && errors.push('Introduza uma data');
                return errors
            },
        },
    }
</script>

<style scoped>

</style>